// ProjectsSection.js
import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const ProjectsSection = () => {
	const [activeFilter, setActiveFilter] = useState(".works-col");

	const filters = [
		{ label: "All", dataHref: ".works-col" },
		{ label: "JavaScript", dataHref: ".sorting-javascript" },
		{ label: "ReactJS", dataHref: ".sorting-react-js" },
		{ label: "NodeJs", dataHref: ".sorting-node-js" },
		{ label: "Python", dataHref: ".sorting-python" },
		{ label: "PHP", dataHref: ".sorting-php" },
	];

	// Optimized projects data with SEO-friendly slugs and improved metadata
	const projects = [
		{
			id: 1,
			slug: "guided-sales-experience",
			classes: "works-col sorting-node-js sorting-react-js",
			linkHref: "/projects/guided-sales-experience",
			imageSrc: "assets/images/work/GSA.webp",
			imageAlt:
				"Guided Sales Experience – Revolutionizing Customer Engagement by Murtaza Lightwala",
			name: "Guided Sales Experience – Revolutionizing Customer Engagement",
			nameStyle: { fontSize: "48px" },
			categories:
				"Node.js<br />ReactJS<br />WebRTC<br /><em>Sales Sorcery</em>",
		},
		{
			id: 2,
			slug: "virtual-try-on-vto",
			classes: "works-col sorting-node-js sorting-react-js",
			linkHref: "/projects/virtual-try-on-vto",
			imageSrc: "assets/images/work/vto.webp",
			imageAlt:
				"Virtual Try-On (VTO) – Redefining E-commerce with 3D Visualization by Murtaza Lightwala",
			name: "Virtual Try-On (VTO) – Redefining E-commerce with 3D Visualization",
			nameStyle: { fontSize: "48px" },
			categories:
				"Node.js<br />ReactJS<br />Three.js<br /><em>Fashion Meets Code</em>",
		},
		{
			id: 3,
			slug: "fitting-height-calculator",
			classes: "works-col sorting-javascript",
			linkHref: "/projects/fitting-height-calculator",
			imageSrc: "assets/images/work/FH.webp",
			imageAlt:
				"Fitting Height Calculator – Precision Eyewear Fitting by Murtaza Lightwala",
			name: "Fitting Height Calculator – Precision Eyewear Fitting",
			nameStyle: { fontSize: "48px" },
			categories: "JavaScript<br />AI Algorithms<br /><em>Size Matters</em>",
		},
		{
			id: 4,
			slug: "pupil-distance-calculator",
			classes: "works-col sorting-javascript",
			linkHref: "/projects/pupil-distance-calculator",
			imageSrc: "assets/images/work/pd.webp",
			imageAlt:
				"Pupil Distance Calculator – Defining Accuracy by Murtaza Lightwala",
			name: "Pupil Distance Calculator – Defining Accuracy",
			nameStyle: { fontSize: "48px" },
			categories:
				"JavaScript<br />AI Algorithms<br /><em>Eyes on the Prize</em>",
		},
		{
			id: 5,
			slug: "pupils-mosaic",
			classes: "works-col sorting-python",
			linkHref: "/projects/pupils-mosaic",
			imageSrc: "assets/images/work/mosaic.webp",
			imageAlt:
				"Pupils Mosaic – Seamless Image Stitching Tool by Murtaza Lightwala",
			name: "Pupils Mosaic – Seamless Image Stitching Tool",
			nameStyle: { fontSize: "48px" },
			categories: "Python<br />OpenCV<br /><em>Pixel Perfection</em>",
		},
		{
			id: 6,
			slug: "optiqual",
			classes: "works-col sorting-python",
			linkHref: "/projects/optiqual",
			imageSrc: "assets/images/work/opti-qual.webp",
			imageAlt:
				"OptiQual – Automated Pupil Image Analysis by Murtaza Lightwala",
			name: "OptiQual – Automated Pupil Image Analysis",
			nameStyle: { fontSize: "48px" },
			categories: "Python<br />AI Analysis<br /><em>Eye Spy Technology</em>",
		},
		{
			id: 7,
			slug: "skoolstream",
			classes: "works-col sorting-node-js sorting-react-js",
			linkHref: "/projects/skoolstream",
			imageSrc: "assets/images/work/ss.webp",
			imageAlt: "SkoolStream – Next-Gen Digital Classroom by Murtaza Lightwala",
			name: "SkoolStream – Next-Gen Digital Classroom",
			nameStyle: { fontSize: "48px" },
			categories:
				"Node.js<br />ReactJS<br />MySQL<br /><em>Learning Unleashed</em>",
		},
		{
			id: 8,
			slug: "intranet",
			classes: "works-col sorting-node-js sorting-react-js",
			linkHref: "/projects/intranet",
			imageSrc: "assets/images/work/intranet.webp",
			imageAlt:
				"Intranet – Enhancing Corporate Communication by Murtaza Lightwala",
			name: "Intranet – Enhancing Corporate Communication",
			nameStyle: { fontSize: "48px" },
			categories:
				"Node.js<br />ReactJS<br />Firebase<br />Microsoft Graph API<br /><em>Office Zen Mastery</em>",
		},
		{
			id: 9,
			slug: "curriculum-travel-of-america",
			classes: "works-col sorting-php",
			linkHref: "/projects/curriculum-travel-of-america",
			imageSrc: "assets/images/work/ctafieldtrips.webp",
			imageAlt:
				"Curriculum Travel of America – Streamlining Educational Journeys by Murtaza Lightwala",
			name: "Curriculum Travel of America – Streamlining Educational Journeys",
			nameStyle: { fontSize: "48px" },
			categories:
				"JavaScript<br />PHP<br />PostgreSQL<br /><em>Adventure Awaits</em>",
		},
		{
			id: 10,
			slug: "reiki",
			classes: "works-col sorting-php",
			linkHref: "/projects/reiki",
			imageSrc: "assets/images/work/reiki.webp",
			imageAlt: "Reiki – Empowering Wellness through Tech by Murtaza Lightwala",
			name: "Reiki – Empowering Wellness through Tech",
			nameStyle: { fontSize: "48px" },
			categories: "Laravel<br />PHP<br />MySQL<br /><em>Coding for Calm</em>",
		},
		{
			id: 11,
			slug: "amol-annadate",
			classes: "works-col sorting-php",
			linkHref: "/projects/amol-annadate",
			imageSrc: "assets/images/work/Amol.webp",
			imageAlt:
				"Amol Annadate – Innovative Doctor Consulting App by Murtaza Lightwala",
			name: "Amol Annadate – Innovative Doctor Consulting App",
			nameStyle: { fontSize: "48px" },
			categories: "Laravel<br />PHP<br />MySQL<br /><em>Healthcare Hacks</em>",
		},
		{
			id: 12,
			slug: "wordpress-masterpieces",
			classes: "works-col sorting-php",
			linkHref: "/projects/wordpress-masterpieces",
			imageSrc: "assets/images/work/wordpress.webp",
			imageAlt:
				"WordPress Masterpieces – Crafting Dynamic Websites by Murtaza Lightwala",
			name: "WordPress Masterpieces – Crafting Dynamic Websites",
			nameStyle: { fontSize: "48px" },
			categories:
				"JavaScript<br />PHP<br />MySQL<br /><em>Plugin Perfection</em>",
		},
		{
			id: 13,
			slug: "rasoi",
			classes: "works-col sorting-php sorting-javascript",
			linkHref: "/projects/rasoi",
			imageSrc: "assets/images/work/rasoi_small.webp",
			imageAlt:
				"Rasoi – A Delicious Journey into Culinary Tech by Murtaza Lightwala",
			name: "Rasoi – A Delicious Journey into Culinary Tech",
			nameStyle: { fontSize: "48px" },
			categories:
				"JavaScript<br />PHP<br />MySQL<br /><em>Code à la Carte</em>",
		},
	];

	const handleFilter = (filterValue) => {
		setActiveFilter(filterValue);
	};
	
	return (
		<section
			className="section section-bg section-parallax-5"
			id="works-section"
		>
			<div className="container">
				{/* Section Heading */}
				<header className="m-titles">
					<Fade direction="up" triggerOnce>
					<h2
						className="m-title"
					>
						My Projects
					</h2>
					</Fade>
				</header>

				<div className="row row-custom">
					<aside className="col-xs-12 col-sm-12 col-md-3 col-lg-3" />
					<article className="col-xs-12 col-sm-12 col-md-9 col-lg-9 vertical-line">
						{/* Description */}
						<Fade direction="up" triggerOnce>
						<section
							className="text"
						>
							<p>
								{" "}
								Welcome to the grand showcase of my favorite projects that I've{" "}
								<strong>designed and developed</strong> recently! As a seasoned{" "}
								<strong>Senior Software Engineer</strong> and{" "}
								<strong>Team Lead</strong>, I've wrestled with rogue code, tamed
								wild algorithms, and even convinced a few stubborn bugs to take
								permanent vacations. Dive in to discover how I've turned
								caffeine into code using the mighty powers of{" "}
								<strong>React.js</strong>, <strong>Node.js</strong>, and a dash
								of <strong>AI magic</strong>. Prepare yourself for a journey
								through innovation, a sprinkle of humor, and projects so sharp
								they could refactor themselves!{" "}
							</p>{" "}
						</section>
						</Fade>
					</article>
				</div>

				{/* Works */}
				<section className="works-box">
					{/* Filter Links */}
					<nav
						className="filter-links"
						style={{zIndex:"1"}}
					>
						{filters.map((filter, index) => (
							// eslint-disable-next-line
							<a
								key={index}
								href="#"
								className={activeFilter === filter.dataHref ? "active" : ""}
								data-href={filter.dataHref}
								onClick={(e) => {
									e.preventDefault();
									handleFilter(filter.dataHref);
								}}
							>
								{filter.label}
							</a>
						))}
					</nav>

					{/* Projects */}

					<div className="works-items works-list-items row">
						{projects
							.filter((project) => {
								if (activeFilter === ".works-col") return true;
								const projectClasses = project.classes.split(" ");
								return projectClasses.includes(activeFilter.replace(".", ""));
							})
							.map((project) => (
								<article key={project.id} className={project.classes}>
									<div className="works-item">
										<Link to={`/projects/${project.slug}`}>
										<Fade direction="left" triggerOnce>
											<span className="image">
												<span className="img">
													<img src={project.imageSrc} alt={project.imageAlt} />
													<span className="overlay" />
												</span>
											</span>
											</Fade>
											<span className="desc">
									<Fade direction="right" cascade={true} damping={0.5} triggerOnce>
												<span
													className="name "
													style={project.nameStyle}
													dangerouslySetInnerHTML={{ __html: project.name }}
												></span>
												<span
													className="category "
													dangerouslySetInnerHTML={{
														__html: project.categories,
													}}
												/>
									</Fade>
											</span>
										</Link>
									</div>
								</article>
							))}
					</div>
				</section>
			</div>
		</section>
	);
};

export default ProjectsSection;
